<template>
  <el-dialog
    :title="title"
    :before-close="closeDialog"
    :visible.sync="isShow"
    :show-close="(active==3 || isAllFailed || (selectPrinterForm.isOnlyApply&&isApplyOrderFinished))"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="711px">
    <!--打印组件检测提示 -->
    <printWarningTip
      :alertTitle="alertTitle"
      :selectPrinterForm="selectPrinterForm"
    ></printWarningTip>
    <!--打印步骤展示 -->
    <div v-if="!selectPrinterForm.isOnlyApply" class="y-f y-f-jb y-f-a print-step">
      <div class="step1 y-t-ac">
        <div class="y-mb-5 y-p-r">
          <div v-if="active==1" class="print-text-icon text-active">1</div>
          <img v-else class="print-step-icon" src="@/assets/images/dianshang/printFinish.png" />
          <div class="print-line" :class="{'active-border': (active==2 || active ==3)}"></div>
        </div>
        <span :class="{'process-blue': active==1}">获取运单号</span>
      </div>
      <div class="step2 y-t-ac">
        <div class="y-mb-5 y-p-r">
          <div v-if="active!==3" class="print-text-icon wait-gray" :class="{'text-active': active==2}">2</div>
          <img v-else class="print-step-icon" src="@/assets/images/dianshang/printFinish.png" />
          <div class="print-line" :class="{'active-border': active ==3}"></div>
        </div>
        <span :class="{'process-blue': active==2, 'wait-gray-text': active== 1}">开始打印</span>
      </div>
      <div class="step3 y-t-ac">
        <div class="y-mb-5">
          <div v-if="active!=3" class="print-text-icon wait-gray">3</div>
          <img v-else class="print-step-icon" src="@/assets/images/dianshang/printSuccess.png" />
        </div>
        <span :class="{'process-blue': active==3, 'wait-gray-text': active!= 3}">打印成功</span>
      </div>
    </div>
    <!--仅取号展示 -->
    <div class="successAll" v-if="selectPrinterForm.isOnlyApply&&isApplyOrderFinished">
      <i class="el-icon-success"></i>
      <p>全部获取成功</p>
    </div>
    <!--第一步提示语 -->
    <div class="tip-desp" v-if="active==1 && !isApplyOrderFinished">正在为：<span class="y-fc-4C84FF">{{curOrderNumber}}</span> 获取运单，等待中请勿操作当前页面</div>
    <!--第二步提示语及进度条 -->
    <div class="tip-desp y-fs-16" v-if="active==2">
      <div>正在向打印机发送数据......</div>
      <el-progress :percentage="printPercentage" :stroke-width="8" style="width: 400px;margin: 0 auto;"></el-progress>
    </div>
    <!--第三步提示语 -->
    <div class="tip-desp y-fs-16" v-if="active==3">打印机打印完成后，请在 <span class="y-fc-4C84FF">已打印</span> 界面查看打印记录</div>
    <!--拉单失败弹层 -->
    <el-dialog
      width="600px"
      title="运单号获取详情"
      custom-class='applyErrorAlert'
      :visible.sync="innerVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :before-close="closeInnerDiaolg"
      append-to-body>
      <div>
        <div v-if="successList.length">
          <div class="y-mb-15">本次共选择了 {{data.length}} 个订单，应获取 {{selectPrinterForm.isMultiWaybill && selectPrinterForm.manyWayBillNum > 1 ? (data.length * selectPrinterForm.manyWayBillNum) : data.length}} 个运单号;</div>
          <div class="y-mb-15">已成功为 <span class="y-fc-36C626">{{selectPrinterForm.isMultiWaybill && selectPrinterForm.manyWayBillNum > 1 ? (data.length - failedList.length) : successList.length}}</span> 个订单获取了 <span class="y-fc-36C626">{{successList.length}}</span> 个运单，有 <span class="y-fc-F56C6C">{{failedList.length}}</span> 个订单获取运单号失败。</div>
        </div>
        <div v-else class="y-mb-15">本次共选择了 {{data.length}} 个订单，均 <span class="y-fc-F56C6C">未成功获取</span> 运单</div>
        <el-table :data="failedList" max-height="400">
          <el-table-column property="logisticNo" label="订单编号" width="200">
            <template slot-scope="scope">
              <div>{{scope.row.customLogisticNo || scope.row.logisticNo}}</div>
          </template>
          </el-table-column>
          <el-table-column property="errorMsg" label="失败原因"></el-table-column>
        </el-table>
        <div class="dialog-footer y-mt-20 y-t-ac">
          <el-button @click="closeInnerDiaolg" v-if="!selectPrinterForm.isOnlyApply">放弃打印</el-button>
          <el-button class="border-btn" @click="copyOrderNoListFn">复制出错订单编号</el-button>
          <el-button type="primary" @click="continuePrintFn" :disabled="!successList.length" v-if="!selectPrinterForm.isOnlyApply">只打印正常订单</el-button>
        </div>
      </div>
    </el-dialog>
    <div style="margin-top:20px;text-align:center;">
      <el-button type="primary" class="y-w-100" @click="closeDialog" v-if="(active==3 || isAllFailed || (selectPrinterForm.isOnlyApply&&isApplyOrderFinished))">关闭</el-button>
    </div>
  </el-dialog>
</template>

<script>
import util from '@/utils/util';
import cnPrint from '@/utils/cainiaoPrint';
import printWarningTip from '@/components/printWarningTip/printWarningTip'; // 打印组件未识别提示语
import { compareObj, dateFormat, copyText, delManySpace } from '@/utils/util';
import { getYTOTemplateApi, getZTOApplyWaybillV2Api, getApplyWaybillByKcodeApi } from '@/api/waybillPrint/customPrint';
import { applyWaybillResultApi } from '@/api/waybillPrint/commonPrint';
import { printSpecialOrderApi } from '@/api/waybillPrint/sepecialOrderPrint';
export default {
  components: {
    printWarningTip // 打印组件未识别提示语
  },
  computed: {
    userMess() {
      return this.$store.state.user;
    },
    isShowRealName() {
      let host = window.location.host;
      return !host.match(/^kh.yto.net.cn/i)
    }
  },
  data() {
    return {
      isShow: this.visible,
      active: 1,
      title: '',
      alertTitle: '',
      nowNum: 0,
      successAll: false,
      errOrders: [],
      pddAlertTitle: '',
      dyAlertTitle: '',
      xhsAlertTitleNew: '',
      dygfWaybillList: util.dygfWaybillList || [], // 抖音官方模板
      errorApplyList: [], // 拉单接口异常错误信息
      isApplyOrderFinished: false, // 是否拉单完成
      printBatch: '', // 批次由父组件生成
      curOrderNumber: '', // 当前正在获取运单号的订单
      failedList: [], // 拉单失败数据
      successList: [], // 拉单成功数据
      innerVisible: false, // 内嵌表格开关
      defaultTempUrl: {}, // 当前打印模板
      printPercentage:0, // 计算的打印进度
      isAllFailed: false, // 是否全部拉单失败
      data: {},
      tempInfo: {},
      selectPrinterForm: {},
      senderInfo: {},
      netSendInfo: {},
      isRepeatPrint: false,
      isSinglePrint: false,
      printerIndex: '',
      totalWaybillNum: 0,
      curPrintMailNoList: [], // 已发送给打印机的运单号集合， 用于发送打印任务时去重处理，防止重复下发打印任务
    };
  },
  methods: {
    init() {
      this.isShow = true;
      this.alertTitle = cnPrint.printerObj.alertTitle;
      this.errOrders = [];
      this.nowNum = 0;
      this.active = 1; // 当前订单状态，第一步，共三步
      this.isApplyOrderFinished = false;
      this.batchPrinting();
    },
    closeDialog() {
      this.resetStatusFormDialog();
      this.$emit('close-print-dialog');
    },
    // 弹层状态重置
    resetStatusFormDialog() {
      this.isShow = false;
      this.active = 1;
      this.errOrders = [];
      this.isApplyOrderFinished = false;
      this.curOrderNumber = '';
      this.failedList = []; // 拉单失败数据
      this.successList = []; // 拉单成功数据
      this.innerVisible = false; // 内嵌表格开关
      this.defaultTempUrl = {}; // 当前打印模板
      this.isAllFailed = false;
      this.curPrintMailNoList = [];
    },
    // 获取自定义区模板
    getCustomPrintTemplate() {
      return new Promise((resolve, reject) => {
        getYTOTemplateApi().then(res => {
          if (res.message === 'ok') {
            let templateList = res.data;
            let tempTemplate = templateList.filter(item => { return item.templateCode === this.tempInfo.templateCode; });
            let customTempTemplateUrl = templateList.filter(item => { return item.templateCode === this.tempInfo.templateTypeCode; });
            let paramsObj = {
              defaultTmpl: customTempTemplateUrl.length ? customTempTemplateUrl[0].templateUrl : '',
              customTempUrl: tempTemplate.length ? tempTemplate[0].templateUrl : ''
            };
            resolve(paramsObj);
          } else {
            resolve({defaultTmpl:'', customTempUrl:''});
          }
        }).catch(() => {
          resolve({defaultTmpl:'', customTempUrl:''});
        });
      });
    },
    // 分批次拉单
    getOrderListSplit(data) {
      return new Promise((resolve, reject) => {
        if (data) {
          this.curOrderNumber = data[0].mallOrderNo || data[0].orderCode;
          let params = {
            pickUpOrderNoList: data.map(item => item.pickupOrderNo),
          };
          // 拉单
          printSpecialOrderApi(params).then(res => {
            if (res.success && res.data) {
              let successlist = (res.data.true || []).map(t => { return {
                ...t,
                isSuccess: true
              }});
              let failList = (res.data.false || []).map(t => { return {
                ...t,
                isSuccess: false
              }});

              successlist = successlist.concat(failList || []);
              resolve(successlist);
            } else {
              let orderList = data.map(item => {
                return {
                  logisticNo: item.pickupOrderNo,
                  errorMsg: res.message || '拉单接口失败，请稍候重试'
                };
              });
              resolve(orderList);
            }
          }).catch(() => {
            let orderList = data.map(item => {
              return {
                logisticNo: item.pickupOrderNo,
                errorMsg: '网络错误，请稍候重试'
              };
            });
            resolve(orderList);
          });
        }
      });
    },
    // 数组10个分组
    splitArr(list) {
      // 将选中的数据每10个分成一组, 并给每组的第一个数据添加taskId,提前生成taskId，防止重复生成taskId
      let result = [];
      for (let i = 0; i < list.length; i += 10) {
        let childList = list.slice(i, i + 10);
        let taskId = `task_${util.getUUID(8, 16)}|${this.printBatch}`;
        childList[0].taskId = taskId;
        result.push(childList);
      }
      return result;
    },
    // 多条打印
    async batchPrinting() {
      this.title = '获取运单号';
      this.active = 1;
      this.nowNum = 0;
      let _this = this;
      // 获取打印模板
      let customTempUrlObj = await this.getCustomPrintTemplate(); // 拉取自定义区模板;       
      this.defaultTempUrl = {
        defaultTmpl: customTempUrlObj.defaultTmpl, // 获取标准模板
        customTempUrl: customTempUrlObj.customTempUrl
      };
      console.log('--2222------', this.defaultTempUrl);
      // 判断打印模板是否正常获取到
      if (!this.defaultTempUrl.defaultTmpl) {
        console.log('-----------', this.defaultTempUrl);
        this.$alert('获取打印模板失败，请关闭弹窗后重试', '提示', {
          confirmButtonText: '确定',
          callback: action => {
            this.closeDialog();
          }
        });
        return false;
      }
      let result = [];
      _this.data.sort(compareObj('logisticNo'));
      
      // 非一单多包裹，每10条订单调用一次拉单接口----将选中的数据每10个分成一组
      for (let i = 0; i < _this.data.length; i += 10) {
        result.push(_this.data.slice(i, i + 10));
      }
      
      // 整合所有拉单返回结果
      let allList = [];
      for (let j = 0; j < result.length; j++) {
        let arr = await this.getOrderListSplit(result[j])
        allList = allList.concat(arr);
      }
      // 全部拉单完成
      this.isApplyOrderFinished = true;
      // 所有拉单失败结果
      this.failedList = allList.filter(o => {return !(o.waybillNo && o.isSuccess)});
      // 所有拉单成功结果
      this.successList = allList.filter(o => {return (o.waybillNo && o.isSuccess)});
      
      this.totalWaybillNum = this.successList.length; // 面单总个数
      this.isAllFailed = this.failedList.length == allList.length // 是否全部拉单失败
      if (this.failedList.length) {
        console.log('successList', this.successList);
        // 有拉单失败的，则显示拉单失败弹框
        this.innerVisible = true;
      } else {
        // 没有拉单失败的，则正常进入打印步骤
        this.continuePrintFn();
      }
    },
    // 继续打印
    continuePrintFn() {
      this.innerVisible = false;
      // 如果是仅取号，则不需要打印
      if (this.successList.length && !this.selectPrinterForm.isOnlyApply) {
        // 缓存批次打印信息，用于打印日志获取参数
        let printListRecord = [];
        let printRecordParams = localStorage.getItem('gPPP');
        if (printRecordParams) {
          printListRecord = JSON.parse(printRecordParams);
          if (printListRecord.length > 2) {
            printListRecord = printListRecord.slice(printListRecord.length-2);
          }
        }
        printListRecord.push(this.getParams({}));
        localStorage.setItem('gPPP', JSON.stringify(printListRecord));
        // 处理打印，需分成10个一组打印
        let newSuccessList = this.splitArr(this.successList);
        // 正常给打印机任务
        this.title = '开始打印';
        this.active = 2;
        this.nowNum = 0; // 开始序号
        for (let j = 0; j < newSuccessList.length; j++) {
          let childList = newSuccessList[j];
          this.batchPrintOrders(childList, j);
        }
      }
    },
    // 多条打印
    batchPrintOrders(list, paramsIi) {
      let printList = [];
      let randomTaskId = list[0].taskId;
      for (let i = 0; i < list.length; i++) {
        let value = list[i];
        // 展示打印进展，当前打印第几条
        ++this.nowNum;
        // 收集面单显示数据--正常面单及签单返还母单数据收集
        let oldDataInfo = {
          // 非加密串字段--普通面单打印
          OrderNumber: value.pickupOrderNo,
          CustomLogisticNo: value.pickupOrderNo,
          LogisticCode: value.waybillNo,
          MailNo: value.waybillNo,
          ToName: value.receiveName || '',
          ToMobile: value.receiveMobile || '',
          ToTelphone: value.receivePhone || '',
          ToAdress: `${value.receiveProvince}${value.receiveCity}${value.receiveCounty}${value.receiveAddress}`,
          ToProvince: value.receiveProvince || '',
          FromName: value.sendName || '',
          FromMobile: value.sendMobile || '',
          FromTelphone: value.sendPhone || '',
          FromCity: `${value.sendProvince}${value.sendCity}${value.sendCounty}${value.sendAddress}`,
          Remark: value.remark || '', // 卖家备注
          BuyerMemo: '', // 买家备注信息
          Volume: '',
          Weight: '',
          Items: [],
          isShowLogo: this.tempInfo.isShowLogo || 'N', // 面单是否打印logo
          ThreeSegmentCode: value.shortAddress || '', // 三段码
          PackageName: value.packageCenterName || '', // 集包地
          PackagePosition: value.packageCenterCode || '', // 集包地编码
          printNum: value.printNum || '', // 面单重复打印次数
          totalNum: this.totalWaybillNum, // 总面单个数
          curNum: this.nowNum || '', // 当前打印面单个数
          printKeyWord: value.printKeyWord || '', // 圆准达面单中返回的五级地址
          // 增值服务类型
          InsuranceValue: value.supportValue ? value.supportValue : 0, // 保价金额
          agencyFund: value.agentValue ? value.agentValue : 0, // 代收金额
          Buy_service_fee: value.apvalue ? value.apvalue : 0, // 到付金额
          // 加密串字段---CN/PDD 打印
          printData: value.printData || '',
          // 拼多多面单所需字段
          orderSn: value.pickupOrderNo, // 拼多多订单号
          trackingNumber: value.waybillNo, // 拼多多运单号
          sendCity: `${value.sendProvince},${value.sendCity},${value.sendCounty}`,
          sendAddress: delManySpace(value.sendAddress) || '',
          sendName: value.sendName || '',
          sendMobile: value.sendMobile || '',
          sendPhone: value.sendPhone || '',
          receiveName: value.receiveName || '',
          receiveMobile: value.receiveMobile || '',
          receivePhone: value.receivePhone || '',
          receiveAddress: `${value.receiveProvince}${value.receiveCity}${value.receiveCounty}${value.receiveAddress}`,
          logisticsId: value.logisticsId || '', // 快递公司id
          mallId: value.mallId || value.mallCode ||'', // 店铺id
          mallName: value.mallName || '', // 店铺id
          buyerMemo: '', // 买家留言
          remark: value.remark || '', // 卖家备注
          brandName: value.brandName || '', // 品牌名
          // 其它电商平台兼容字段
          Id: value.id || '',
          id: value.id || '',
          pid: value.pid || '',
          // 顺丰面单信息
          sfWaybillData: value.sfWaybillData,
          // 海外面单信息
          OrderType: util.hwWaybillList.includes(this.tempInfo.baseTempId) ? '5' : null,
          // 签单返还类型
          serviceSignType: (value.signBackWaybillInfo && value.signBackWaybillInfo.mailNo) ? '签单返还' : '',
          isTCJ: value.arriveFlag && value.arriveFlag == '7' ? 'Y' : 'N', // 同城件标记
          isHKJ: value.arriveFlag && value.arriveFlag == '9' ? 'Y' : 'N', // 航空件标记
          isYZD: value.platformCode == 'YTO_ZD' ? 'Y' : 'N', // 圆准达标记
          promiseType: value.promiseType == '1' ? '送货上门': ((value.promiseType == '2' || value.promiseType == '3') ? '电联确认' : '') // 圆准达模板类型  1 送货上门  2和3 电联确认
        };
        console.log('this.tempInfo.goodsNumUnit', this.tempInfo.goodsNumUnit)
        let goodsTotal = 0;
        let goodsTotalPrice = 0;
        (value.goodLists || []).forEach(item => {
          goodsTotal += Number(item.goodNum || 1);
          goodsTotalPrice += Number(item.goodsPrice || 0) * Number(item.goodNum || 1); //订单总金额
          let proInfo = {};
          proInfo.goodsname = item.goodName || '';
          proInfo.goodsnum = (item.goodNum || 1) + `(${this.tempInfo.goodsNumUnit || '件'})`;
          proInfo.goodsspec = item.goodSpecs || ''; // 商品规格
          proInfo.skucode = ''; // 商品编码
          proInfo.goodscode = item.goodscode || ''; // 商品编码
          proInfo.item_short_name = item.goodShortName || ''; // 商品简称
          proInfo.goodsprice = (item.goodsPrice || 0) + '(元)'; // 商品编码
          oldDataInfo.Items.push(proInfo);
        });
        oldDataInfo.Items = JSON.stringify(oldDataInfo.Items);
        oldDataInfo.goodsTotal = goodsTotal + `(${this.tempInfo.goodsNumUnit || '件'})`; // 商品总数
        oldDataInfo.goodsTotalPrice = goodsTotalPrice; //订单总金额
        oldDataInfo.presentInfo = ''; // 赠品信息
        
        let obj = {value: oldDataInfo, oldData: oldDataInfo};
        printList.push(obj);
      }
      this.printData(printList, randomTaskId, '', paramsIi);
    },
    // 打印组件传递任务
    printData(parintDataList, taskId, encrypt, paramsIi) {
      /*
        this.printerIndex 指定打印机
        parintDataList 拉单的数据
        tempInfo 自定义打印信息
        defaultTmpl，defaultTempUrl 打印模板链接
        isEncrypt 是否加密---原单重打，使用老淘宝拉单接口打印，不用加密串
        callback 回调
      */
      let curMailNoList = parintDataList.map(o => {return o.oldData.MailNo; });
      console.assert(false, curMailNoList)
      // console.log('curMailNoList', curMailNoList);
      // 当前任务中的运单号如没有被打印过，则下发打印任务
      if (!this.curPrintMailNoList.includes(curMailNoList[0])) {
        this.curPrintMailNoList = this.curPrintMailNoList.concat(curMailNoList);
        cnPrint.printHtml(
          this.printerIndex,
          parintDataList,
          this.tempInfo,
          this.defaultTempUrl,
          false, // 普通面单用非加密串打印
          'YTO',
          taskId
        );
        // 保存日志参数
        let paramsObj = {
          parintDataList,
          taskId,
          splitI: paramsIi,
          totalNum: this.successList.length,
          platFormCode: 'YTO_DIY',
          printBatch: this.printBatch
        };
        applyWaybillResultApi(paramsObj);
      }
      // 计算进度
      this.printPercentage = Math.floor((Number(this.nowNum) / this.successList.length)*100);// 计算打印进度
      if (this.nowNum == this.successList.length) {
        this.title = '打印成功';
        this.active = 3;
      }
    },
    // 打印日志参数获取
    getParams(params) {
      let recordParams = {
        printUserId: this.userMess.loginId,
        platFormCode: 'YTO_DIY', // 平台类型code
        platFormName: '自定义', // 平台名称
        printBatch: this.printBatch, // 批次
        printSequence: params.printSequence || '', // 次序
        printStatus: params.printStatus || '', // 打印状态（Y/N）
        mailNo: params.mailNo || '', // 运单号
        expressModelId: this.tempInfo.baseTempId, // 快递单模板基础类型
        cpCode: this.tempInfo.wpCode, // 快递模板公司
        printModel: this.tempInfo.id, // 快递单模板id
        printModelName: this.tempInfo.tempName, // 快递模板名称
        printOrderNum: this.totalWaybillNum, // 批次下所有拉单返回的运单号总数
        printTime: params.printTime || dateFormat(new Date(), 'yyyy-MM-dd hh:mm:ss'), // 打印时间
        printerName: this.printerIndex, // 打印机名称
        printNum: '', // 重复打印次数
        shopName: '', // 店铺名称
        shopId: '', // 店铺id
        taskId: '', // 任务id
        applyOrderAccount: this.tempInfo.printAccount || ''
      }
      return recordParams;
    },
    // 复制拉单失败订单号
    copyOrderNoListFn() {
      let orderNoList = this.failedList.map(o => { return o.customLogisticNo || o.logisticNo;})
      let orderNoStr = orderNoList.join('\n');
      copyText(orderNoStr);
    },
    // 关闭内嵌弹窗
    closeInnerDiaolg() {
      this.innerVisible = false;
      this.closeDialog();
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" rel="stylesheet/scss" scoped>
@import "../../../../styles/variables";
.alert {
  margin-bottom: 30px;
}
.el-dialog__wrapper .successAll {
  text-align: center;
  color: $blue-style;
  i {
    font-size: 30px;
  }
  p {
    font-size: 16px;
    margin-bottom: 0;
  }
}
.el-dialog__header .el-dialog__title {
  font-size: 16px;
}
.tip-desp {
  margin-top: 20px;
  font-size: 14px;
  text-align: center;
  line-height: 40px;
}
</style>
